export default __webpack_public_path__ + "static/media/screen-sl.b277aee7.svg";